import React from 'react';
import PropTypes, { object } from 'prop-types';

import { Heading, Text } from 'components/common/Elements/Elements';

import classes from './CustomTooltip.module.scss';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload[0].payload) {
    return (
      <div className={classes.box}>
        <Heading className={classes.title}>{label}</Heading>
        {payload.map(item => {
          return (
            <Text type="p" className={classes.item} key={item.dataKey}>
              <Text>
                <img
                  alt=""
                  className={classes.color}
                  style={{ backgroundColor: item.fill }}
                />
                <Text className={classes.name}>{item.dataKey}:</Text>
              </Text>
              <Text>
                <Text className={classes.text}>
                  {item.payload[item.dataKey]}%
                </Text>
                <Text className={classes.text}>
                  {item.payload[`${item.dataKey}-count`]}
                </Text>
              </Text>
            </Text>
          );
        })}
      </div>
    );
  }

  return null;
};

CustomTooltip.propTypes = {
  payload: PropTypes.arrayOf(object),
  active: PropTypes.bool,
  label: PropTypes.string
};

export default CustomTooltip;
